// Modo debug para obtener datos de .json
export const debug = process.env.NODE_ENV == 'development'

// Url del gestor de archivos
export const url_gestor_archivos = process.env.NODE_ENV == 'production' ? '/SiDMS.UPD/' : "http://localhost:8081/"

// Informacion para filtros de buscador
export const types_input = {
    1: 'date',
    2: 'text',
    3: 'number',
    4: 'autosuggest',
    5: 'autosuggest',
    6: 'text',
    8: 'autosuggest',
    9: 'text',
    10: 'date',
    11: 'text',
    12: 'number',
    13: 'autosuggest',
    14: 'date',
}

export const filters_operator = [
{
    id: 1,
    label: 'Igual',
    operator: '='
}, {
    id: 2,
    label: 'Mayor/igual',
    operator: '>='
}, {
    id: 3,
    label: 'Menor/igual',
    operator: '<='
}, {
    id: 4,
    label: 'Mayor',
    operator: '>'
}, {
    id: 5,
    label: 'Menor',
    operator: '<'
}, {
    id: 6,
    label: 'Contiene',
    operator: '@'
}, {
    id: 7,
    label: 'Empieza',
    operator: '['
}, {
    id: 8,
    label: 'Termina',
    operator: ']'
}, {
    id: 9,
    label: 'Entre',
    operator: '<>'
}, {
    id: 10,
    label: 'Diferente',
    operator: '!='
}, {
    id: 11,
    label: 'No contiene',
    operator: '!@'
}, {
    id: 12,
    label: 'Lista',
    operator: '≡'
}
]

export const filters_search = [
{
    key: 'emisor__id',
    tagKey: 'emisor__id',
    lista: 1,
    placeholder: 'Emisor',
    comparador: 1,
    type: 'text',
    value: ''
}, {
    key: 'receptor__id',
    tagKey: 'receptor__id',
    lista: 2,
    placeholder: 'Receptor',
    comparador: 1,
    type: 'text',
    value: ''
}, {
    key: 'proyecto__id',
    tagKey: 'proyecto__id',
    lista: 3,
    placeholder: 'Proyecto',
    comparador: 1,
    type: 'text',
    value: ''
}, {
    key: 'departamento__id',
    tagKey: 'departamento__id',
    lista: 4,
    placeholder: 'Departamento',
    comparador: 1,
    type: 'text',
    value: ''
}, {
    key: 'estado__id',
    tagKey: 'estado__id',
    lista: 5,
    placeholder: 'Estado',
    comparador: 1,
    type: 'text',
    value: ''
}, {
    key: 'ano',
    tagKey: 'ano',
    placeholder: 'Año',
    comparador: 1,
    type: 'number',
    value: ''
}, {
    key: 'description',
    tagKey: 'descripcion',
    placeholder: 'Descripción',
    comparador: 1,
    type: 'text',
    value: ''
}
]

export const filters_date = [
{
    key: 'propiedad_creado',
    tagKey: 'created_at',
    format: 'YYYY-MM-DD HH:mm:ss',
    placeholder: 'Creación',
    comparador: 1,
    type: 'text',
    value: ''
}, {
    key: 'propiedad_modificado',
    tagKey: 'updated_at',
    format: 'YYYY-MM-DD HH:mm:ss',
    placeholder: 'Modificación',
    comparador: 1,
    type: 'text',
    value: ''
}, {
    key: 'propiedad_caducidad',
    tagKey: 'fecha_caducidad',
    format: 'YYYY-MM-DD',
    placeholder: 'Caducidad',
    comparador: 1,
    type: 'text',
    value: ''
}, {
    key: 'propiedad_fecha',
    tagKey: 'fecha_documento',
    format: 'YYYY-MM-DD',
    placeholder: 'Documento',
    comparador: 1,
    type: 'text',
    value: ''
}
]

// Tipos de input en componente propiedades
export const input_types = {
    1: 'datepicker',
    2: 'text',
    3: 'number0decimals',
    4: 'selectAsync',
    5: 'selectAsync',
    6: 'text',
    8: 'selectAsync',
    9: 'text',
    10: 'datepicker',
    11: 'text',
    12: 'number2decimals',
    13: 'selectAsync',
    14: 'datepicker',
    15: 'text',
    16: 'selectAsyncUsers'
}
